export const config = {
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  REACT_WS_PAY_URL: process.env.REACT_WS_PAY_URL,
  REACT_FRONTEND_BASE_URL: process.env.REACT_FRONTEND_BASE_URL,
  REACT_PRODUCTION_FRONTEND: process.env.REACT_PRODUCTION_FRONTEND_BASE_URL,
};
